export const IsHtmlSelectorValid = (selector: string) => {
	let targetElement: Element | null = null;

	try {
		targetElement = document.querySelector(selector);

		if (targetElement === null) {
			return false;
		}
	} catch (e) {
		return false;
	}

	return true;
};
